import React from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';
import { pdfColors, pdfFontFamily } from '../theme';
import { OFFICIAL_BODY } from './OfficialPage';

const styles = StyleSheet.create({
  box: {
    marginTop: 2, marginBottom: 14, paddingVertical: 6, paddingHorizontal: 12,
    borderLeftWidth: 1.5, borderLeftColor: pdfColors.textPrimary, borderLeftStyle: 'solid',
    backgroundColor: pdfColors.surfaceSoft,
  },
  row: { flexDirection: 'row', paddingVertical: 3 },
  label: { width: 140, fontFamily: pdfFontFamily.serifItalic, fontSize: OFFICIAL_BODY - 0.5, color: pdfColors.textSecondary },
  value: { flex: 1, fontFamily: pdfFontFamily.serifBold, fontSize: OFFICIAL_BODY - 0.5 },
});

/** Label–value pairs set off from an official document's text: italic label, bold value, a dark rule at the left. */
const DetailsBox: React.FC<{ rows: Array<[string, string]>; labelWidth?: number }> = ({ rows, labelWidth }) => (
  <View style={styles.box} wrap={false}>
    {rows.map(([label, value]) => (
      <View key={label} style={styles.row} wrap={false}>
        <Text style={labelWidth ? [styles.label, { width: labelWidth }] : styles.label}>{label}</Text>
        <Text style={styles.value}>{value}</Text>
      </View>
    ))}
  </View>
);

export default DetailsBox;
